import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home/Home';
import Courses from './Pages/Courses/Courses';
import Syllabus from './Pages/Syllabus/Syllabus';
import Assessments from './Pages/Assessment&Certification/Assessments';
import About from './Pages/About/About';
import LearningExperience from './Pages/LearningExperience/LearningExperience';
import ContactUs from './Pages/ContactUs/ContactUs';
import Authentication from './Pages/Authentication/Authentication';
import NotFound from './Pages/NotFound/NotFound';
import CourseDetails from './Pages/Courses/CourseDetails';
import Navbar from './Pages/Navbar/Navbar';
import Footer from './Pages/Footer/Footer';
import Blogs from './Pages/Blogs/Blogs';
import Trainings from './Pages/Trainings/Trainings';
import Teachers from './Pages/Teachers/Teachers';
import Events from './Pages/Events/Events';
import CourseDetails1 from './Pages/Courses/CourseDetails1';
import EngineeringServices from './Pages/EngineeringServices/EngineeringServices';
import Careers from './Pages/Careers/Careers';


const App = () => {

  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />

          <Route path='/user-about' element={<About />} />
          <Route path="/engineering-services" element={<EngineeringServices />} />
          <Route path='/user-courses' element={<Courses />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/user-blogs' element={<Blogs />} />
          <Route path='/trainings' element={<Trainings />} />
          <Route path='/teachers' element={<Teachers />} />
          <Route path='/events' element={<Events />} />
          <Route path='/course-details/:id' element={<CourseDetails1 />} />
          <Route path='/user-authentication' element={<Authentication />} />
          <Route path="/careers" element={<Careers/>}/>


          {/* <Route path='/user-courses/course-details' element={<CourseDetails />} /> */}
          <Route path='/user-syllabus' element={<Syllabus />} />
          <Route path='/user-assessments' element={<Assessments />} />
          <Route path='/user-learningExperience' element={<LearningExperience />} />
          <Route path='/404-Notfound' element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  )
}

export default App;
